<com-web-dialog
    dialogTitle="Notification: Create To-Do"
    icon="fa-kit fa-solid-bell-circle-check"
    [isDraggable]="true">
    <div>
        @if (toDoForm) {
            <div>
                <com-web-form
                    [formGroup]="toDoForm"
                    (submit)="submit()"
                    [doShowFormActions]="false">
                    <div class="flex flex-col space-y-1 mb-4">
                        <div class="flex flex-col">
                            <com-web-textarea
                                label="Description"
                                controlName="description"
                                [required]="true"
                                [numRows]="5"
                                [maxLength]="2000"
                                [doShowMaxLength]="true"></com-web-textarea>
                            <div
                                class="flex flex-col lg:flex-row gap-4 items-stretch">
                                <div class="flex flex-col w-full lg:w-1/3">
                                    <rcp-oup-datepicker
                                        controlName="dueDate"
                                        verticalLabel="Due Date"
                                        [inputWidth]="225"
                                        [minDate]="TODAY"
                                        [showDateQuickSet]="true"
                                        [dateQuickSetPosition]="'below'">
                                    </rcp-oup-datepicker>
                                </div>
                                <div class="flex flex-col w-full lg:w-1/3">
                                    <span
                                        class="block pb-1.5 font-semibold left w-full">
                                        Priority
                                        <span class="text-error-red pl-0.5"
                                            >*</span
                                        >
                                    </span>
                                    <mat-radio-group
                                        class="flex flex-row items-center xl:pt-1.5"
                                        formControlName="priority">
                                        @for (
                                            option of priorityOptions;
                                            track option
                                        ) {
                                            <mat-radio-button
                                                class="mr-4"
                                                [value]="option.value"
                                                >{{
                                                    option.label
                                                }}</mat-radio-button
                                            >
                                        }
                                    </mat-radio-group>
                                </div>
                                <div class="flex flex-row w-full lg:w-1/3">
                                    <div class="grow">
                                        <com-web-select
                                            [options]="accountUsers"
                                            labelVertical="Assigned To"
                                            controlName="ownerId"></com-web-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </com-web-form>
                @if (notificationForm) {
                    <com-web-form
                        [formGroup]="notificationForm"
                        [doShowFormActions]="false">
                        <div
                            class="flex flex-col space-y-3 bg-table-header-bg rounded p-3">
                            <div
                                class="flex flex-row items-center border-b border-b-gray-border pb-2">
                                <div class="space-x-4">
                                    <span class="font-bold">
                                        <i class="fa-solid fa-bell mr-1"></i>
                                        Notification
                                    </span>
                                    <span class="text-sm">{{
                                        notification.createdOn
                                            | date: 'MM/dd/yyyy'
                                    }}</span>
                                    <span class="text-sm">
                                        {{
                                            notification.notificationPriority
                                                | enumLabel
                                        }}
                                        priority
                                    </span>
                                </div>
                            </div>
                            <div>
                                {{ notification.description }}
                            </div>
                            <div class="flex flex-row">
                                <span class="font-semibold mr-4">Status</span>
                                <mat-radio-group
                                    class="items-center"
                                    [(ngModel)]="nextStep"
                                    [ngModelOptions]="{ standalone: true }">
                                    <mat-radio-button
                                        [tabIndex]="0"
                                        [value]="1"
                                        class="mr-4 radio-dark">
                                        Leave as Open
                                    </mat-radio-button>
                                    <mat-radio-button
                                        [tabIndex]="0"
                                        [value]="2"
                                        class="mr-4 radio-dark">
                                        Mark as Cleared
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>
                            @if (nextStep === 2) {
                                <div>
                                    <com-web-textarea
                                        controlName="message"
                                        placeholder="Optional: Enter supporting notation for this Notification."
                                        [tabOrder]="0"
                                        [sideLabelWidth]="145"
                                        [numRows]="3"
                                        [maxLength]="250"
                                        [doShowMaxLength]="
                                            true
                                        "></com-web-textarea>
                                </div>
                            }
                            <div class="flex flex-row text-sm">
                                <span class="mr-1 font-semibold">Note:</span>
                                @if (nextStep === 1) {
                                    <span>
                                        This action will create a To-Do and
                                        leave the Notification status "Open"
                                    </span>
                                }
                                @if (nextStep === 2) {
                                    <span>
                                        This action will create a To-Do and
                                        update the Notification status to
                                        "Cleared"
                                    </span>
                                }
                            </div>
                        </div>
                    </com-web-form>
                }
            </div>
        }
    </div>
    <div footer class="flex flex-col w-[900px]">
        <div class="flex grow w-full justify-end">
            @if (!isSubmitInProcess) {
                <com-web-button
                    [buttonType]="ButtonType.Cancel"
                    (clickEvent)="close()"
                    [tabOrder]="0"></com-web-button>
            }
            <com-web-button
                [buttonStyle]="ButtonStyle.Primary"
                [label]="
                    nextStep === 1
                        ? 'Create To-Do'
                        : 'Mark as Cleared + Create To-Do'
                "
                (clickEvent)="submit()"
                [tabOrder]="0"
                [disabled]="toDoForm.invalid"
                [loading]="isSubmitInProcess"></com-web-button>
        </div>
    </div>
</com-web-dialog>
